import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { CLOSER_ACCOUNTS, setAuth } from "./demoConfig";
import "./demo.css";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const resp = await fetch(`${API}/api/demo/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (resp.ok) {
        const data = await resp.json();
        // Persist the full payload (including token + role) — needed for
        // admin CSV exports and any authenticated backend calls.
        setAuth({
          username: data.username,
          name:     data.name,
          role:     data.role,
          token:    data.token,
        });
        // Mirror into `bja_auth` — this is the key the admin export helpers read.
        try {
          localStorage.setItem("bja_auth", JSON.stringify(data));
        } catch { /* quota */ }
        navigate("/demo/today");
        return;
      }
    } catch {
      // API down — fall back to local auth
    }
    // Fallback: local check
    const match = CLOSER_ACCOUNTS.find(
      (a) => a.username === username && a.password === password
    );
    if (match) {
      setAuth({ username: match.username, name: match.name });
      navigate("/demo/crm");
    } else {
      setError("Incorrect credentials. Contact your manager.");
    }
    setLoading(false);
  };

  return (
    <div className="demo-login-page" data-testid="demo-login-page">
      <div className="demo-login-card">
        <img
          src="https://customer-assets.emergentagent.com/job_jobblast/artifacts/ixjqwc10_image.png"
          alt="BulkJobApply"
          className="demo-login-logo"
        />
        <h1 className="demo-login-heading">Closer login</h1>

        <form onSubmit={handleSubmit} className="demo-login-form">
          <div className="demo-field">
            <Label htmlFor="username">Username</Label>
            <Input
              id="username"
              value={username}
              onChange={(e) => { setUsername(e.target.value); setError(""); }}
              placeholder="Enter username"
              data-testid="login-username"
              autoComplete="off"
            />
          </div>
          <div className="demo-field">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              placeholder="Enter password"
              data-testid="login-password"
            />
          </div>
          {error && <p className="demo-login-error" data-testid="login-error">{error}</p>}
          <Button type="submit" className="demo-login-btn" data-testid="login-submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
